import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=961dc8fc&scoped=true&lang=pug&"
import script from "./AdminHeader.vue?vue&type=script&lang=ts&"
export * from "./AdminHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&id=961dc8fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961dc8fc",
  null
  
)

export default component.exports